import { memo } from "react";
import { Card, CardContent } from "@/core/components/ui/card";
import { Skeleton } from "@/core/components/ui/skeleton";
import { Stack } from "@/core/components/ui/stack";
import { cn } from "@/core/utils/utils";

export const ActivityItemSkeleton = memo(() => (
  <div className="w-[650px]">
    <Card className="w-full overflow-hidden">
      {/* Event label skeleton */}
      <div className={cn("inline-block rounded-br-lg bg-gray-10 px-3 py-1.5")}>
        <Skeleton className="h-4 w-24" />
      </div>
      <CardContent className="p-4 pb-[76px] pt-3">
        <Stack
          direction="row"
          justify="between"
          align="start"
          gap="xl"
          fullWidth
        >
          <Stack gap="xs">
            <Skeleton className="h-4 w-96" />
            <Skeleton className="h-3 w-20" />
          </Stack>
          {/* Badge skeleton */}
          <Skeleton className="h-8 w-10 shrink-0 rounded-lg" />
        </Stack>
      </CardContent>
    </Card>
    <Card className="mx-4 -mt-16 w-[618px] bg-surface-secondary">
      <CardContent className="p-4">
        <Stack gap="sm" fullWidth>
          {/* Trigger Info title skeleton */}
          <Skeleton className="h-4 w-24" />
          {/* Trigger Info content skeleton */}
          <Skeleton className="h-4 w-48" />
        </Stack>
      </CardContent>
    </Card>
  </div>
));

ActivityItemSkeleton.displayName = "ActivityItemSkeleton";
